var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import styled from "styled-components";
import { Switch, Route, Redirect } from "react-router-dom";
import Helmet from "react-helmet";
import { isClient } from "shared/logic";
import { MEDIA_QUERIES } from "shared/style";
import Home from "components/Home";
import Introduce from "components/Introduce";
import Privacy from "components/Privacy";
import Page from "components/shared/Page";
import Header from "./Header";
import MobileHeader from "./Header/MobileHeader";
import Footer from "./Footer";
import Login from "./User/Login";
import Signup from "./User/Signup";
import FindPassword from "./User/FindPassword";
import ModifyInfo from "./User/ModifyInfo";
import Modal from "../Modal";
var RootDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  min-height: 100vh;\n\n  > .content {\n    width: 100%;\n    ", " {\n      margin-top: 60px;\n    }\n  }\n"], ["\n  width: 100%;\n  min-height: 100vh;\n\n  > .content {\n    width: 100%;\n    ", " {\n      margin-top: 60px;\n    }\n  }\n"])), MEDIA_QUERIES.PHONE);
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout(props) {
        var _this = _super.call(this, props) || this;
        _this.previousLocation = null;
        _this.unlistenHistory = null;
        _this.renderHome = function (project) { return React.createElement(Home, { project: project }); };
        _this.closeModal = function (e) {
            e.preventDefault();
            _this.props.history.goBack();
        };
        _this.previousLocation = props.location;
        return _this;
    }
    Layout.prototype.componentDidMount = function () {
        this.unlistenHistory = this.props.history.listen(function () {
            window.scrollTo(0, 0);
        });
    };
    Layout.prototype.componentWillUnmount = function () {
        this.unlistenHistory();
    };
    Layout.prototype.UNSAFE_componentWillUpdate = function (nextProps) {
        var location = this.props.location;
        if (nextProps.history.action !== "POP" &&
            (!location.state || !location.state.modal)) {
            this.previousLocation = this.props.location;
        }
    };
    Layout.prototype.render = function () {
        var _this = this;
        var _a = this.props, project = _a.project, match = _a.match, location = _a.location;
        var commonProps = {
            project: project,
            url: match.url,
        };
        var pages = ["technology", "products", "guide", "database", "customer"];
        var modalRoutes = [
            {
                path: match.url + "/login",
                component: React.createElement(Login, __assign({}, this.props)),
                title: "로그인",
            },
            {
                path: match.url + "/signup",
                component: React.createElement(Signup, __assign({}, this.props)),
                title: "회원가입",
            },
            {
                path: match.url + "/find-password",
                component: React.createElement(FindPassword, __assign({}, this.props)),
                title: "비밀번호 찾기",
            },
            {
                path: match.url + "/modify-info",
                component: React.createElement(ModifyInfo, __assign({}, this.props)),
                title: "회원정보 수정",
            },
        ];
        var isModal = modalRoutes
            .map(function (routes) { return routes.path; })
            .some(function (path) { return location.pathname === path; });
        return (React.createElement(RootDiv, null,
            React.createElement(Helmet, null,
                React.createElement("title", null, "(\uC8FC)\uBAA8\uD604\uC528\uC564\uB514"),
                React.createElement("meta", { name: "description", content: "(\uC8FC)\uBAA8\uD604\uC528\uC564\uB514 \uD648\uD398\uC774\uC9C0 \uBC29\uBB38\uC744 \uD658\uC601\uD569\uB2C8\uB2E4." }),
                React.createElement("meta", { name: "og:title", content: "(\uC8FC)\uBAA8\uD604\uC528\uC564\uB514" }),
                React.createElement("meta", { name: "og:description", content: "(\uC8FC)\uBAA8\uD604\uC528\uC564\uB514 \uD648\uD398\uC774\uC9C0 \uBC29\uBB38\uC744 \uD658\uC601\uD569\uB2C8\uB2E4." }),
                React.createElement("meta", { name: "robots", content: "index, follow" })),
            React.createElement(Header, __assign({}, commonProps)),
            React.createElement(MobileHeader, __assign({}, commonProps)),
            React.createElement("div", { className: "content" },
                React.createElement(Switch, { location: isModal ? this.previousLocation : location },
                    React.createElement(Route, { path: "" + match.url, exact: true, render: function () { return _this.renderHome(project); } }),
                    React.createElement(Route, { path: match.url + "/introduce", render: function () { return React.createElement(Introduce, { project: project }); } }),
                    React.createElement(Route, { path: match.url + "/privacy", render: function () { return React.createElement(Privacy, null); } }),
                    pages.map(function (page, idx) {
                        return (React.createElement(Route, { key: idx, path: match.url + "/" + page, render: function (props) { return (React.createElement(Page, __assign({}, props, { project: project, name: page }))); } }));
                    }),
                    isClient && (isModal ? null : React.createElement(Redirect, { to: "" + match.url })),
                    React.createElement(Route, { component: function () { return _this.renderHome(project); } })),
                isClient
                    ? modalRoutes.map(function (route, idx) { return (React.createElement(Route, { key: idx, path: route.path, render: function (props) { return (React.createElement(Modal, { title: route.title, close: _this.closeModal }, route.component)); } })); })
                    : null),
            React.createElement(Footer, __assign({}, commonProps))));
    };
    return Layout;
}(React.Component));
export default Layout;
var templateObject_1;
